import { Dialog, DialogContent, DialogProps, useForm, FormButton, useAlerts, useFeedback } from "@sis/react-library";
import { FeedbackDto } from "./FormSamplesWithinDialogPage";
import { useState } from "react";
import { callMimicApi } from "../../../../utils/commonUtils";
import { DialogActions, DialogTitle, Typography } from "@mui/material";
import { FormSamplesWithinDialogForm } from "./FormSamplesWithinDialogForm";

interface FormSamplesWithinDialogDialogProps {
    setDisplaySubmittedValues: (values: FeedbackDto | undefined) => void;
}

export const FormSamplesWithinDialogDialog = ({
    //open, closeOnClickOff, onClose, setDisplaySubmittedValues
    open, onClose, setDisplaySubmittedValues
}: DialogProps & FormSamplesWithinDialogDialogProps) => {

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Unlike the other forms, we define the form name in the Dialog Component
    // and not in the Form component
    // This is because the buttons exist in this dialog component and not the form component
    // and therefore buttons are not wrapped within the form component.
    // In order for the buttons to still function with the form it will also require the form name.    
    ///////////////////////////////////////////////////////////////////////////////////////////////////    
    const formName = 'FormWithDialog';

    const [submitting, setSubmitting] = useState(false);
    const { submitForm, resetForm, pristine } = useForm(formName);
    const { confirm } = useAlerts();
    const { showError } = useFeedback();

    const handleSubmit = async (values: FeedbackDto) => {
        setSubmitting(true);
        setDisplaySubmittedValues(values);

        try {
            // In the api call, uncomment the exception in there to test errors coming from the api
            await callMimicApi();
            closeForm();
        } catch (ex) {
            showError(`An error occured: ${ex}`);
            return false;
        } finally {
            setSubmitting(false);
        }
    }

    const handleClose = () => {
        if (pristine) {  // Pristine checks if any changes have been made to the form
            closeForm();
        } else {
            confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
                () => { closeForm() },
                "Yes", "No"
            );
        }
    };

    const closeForm = () => {
        resetForm();
        onClose();
    }

    return (
        <Dialog
            open={open}
            //closeOnClickOff  // Uncomment to close the dialog when mouse clicking off the dialog area
            onClose={handleClose}            
        >
            <DialogTitle>Feedback</DialogTitle>
            <DialogContent width='500px'>
                <Typography>
                    Please provide us with some feedback.
                </Typography>
                <FormSamplesWithinDialogForm
                    formName={formName}
                    onSubmit={handleSubmit}
                    submitting={submitting}
                    open={open}
                />
            </DialogContent>
            <DialogActions>
                <FormButton
                    formButtonText='Cancel'
                    onClick={handleClose}
                    formName={formName}  // We have to pass through the form name because the button is outside the form container
                    submitting={submitting}  // We pass through submitting manually as it can't get it from the form
                    enabledOnPristine
                />
                <FormButton
                    formButtonText='Submit'
                    onClick={submitForm}
                    formName={formName}  // We have to pass through the form name because the button is outside the form container
                    submitting={submitting} // We pass through submitting manually as it can't get it from the form
                    submitButton
                />
            </DialogActions>
        </Dialog>
    )
}
